import { type ReactNode } from 'react';

const colorMap = {
  success: 'border-status-success/30 bg-status-success/10 text-status-success',
  warning: 'border-status-warning/30 bg-status-warning/10 text-status-warning',
  error: 'border-status-error/30 bg-status-error/10 text-status-error',
  info: 'border-status-info/30 bg-status-info/10 text-status-info',
  muted: 'border-border bg-popover text-muted-foreground',
} as const;

export type PillColor = keyof typeof colorMap;

export interface PillProps {
  children: ReactNode;
  icon?: ReactNode;
  color?: PillColor;
  className?: string;
}

export function Pill({ children, icon, color = 'muted', className = '' }: PillProps) {
  return (
    <span
      className={[
        'inline-flex items-center gap-gap-tight rounded-full',
        'px-2.5 py-1 border text-caption',
        colorMap[color],
        className,
      ].join(' ')}
    >
      {icon && <span className="shrink-0">{icon}</span>}
      {children}
    </span>
  );
}
